import styles from './Outro.module.css';

export default function Outro() {
  return (
    <div className={styles.outro}>
      <div className={styles.container}>
        <div className={styles.statusSection}>
          <div className={styles.statusDot} />
          <span className={styles.statusText}>SYSTEM ONLINE</span>
        </div>

        <pre className={styles.ascii}>
{`
    ██████╗  █████╗ ███╗   ██╗██╗  ██╗██╗███╗   ██╗
    ██╔══██╗██╔══██╗████╗  ██║╚██╗██╔╝██║████╗  ██║
    ██████╔╝███████║██╔██╗ ██║ ╚███╔╝ ██║██╔██╗ ██║
    ██╔══██╗██╔══██║██║╚██╗██║ ██╔██╗ ██║██║╚██╗██║
    ██║  ██║██║  ██║██║ ╚████║██╔╝ ██╗██║██║ ╚████║
    ╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝
`}
        </pre>

        <div className={styles.info}>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>VERSION</span>
            <span className={styles.infoValue}>v2.77</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>STATUS</span>
            <span className={styles.infoValue}>OPERATIONAL</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>UPTIME</span>
            <span className={styles.infoValue}>247 DAYS</span>
          </div>
        </div>

        <div className={styles.contact}>
          <h3 className={styles.contactTitle}>CONTACT</h3>
          <div className={styles.contactLinks}>
            <a href="mailto:ranxinstart@gmail.com" className={styles.contactLink}>
              <span className={styles.linkIcon}>✉</span>
              <span>ranxinstart@gmail.com</span>
            </a>
          </div>
        </div>

        <div className={styles.footer}>
          <p>Personal Document Archive · Built with React + Vite</p>
          <p className={styles.copyright}>© 2026 Ranxin · All Rights Reserved</p>
          <p className={styles.icp}>
            <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2021149156号-1</a>
          </p>
        </div>
      </div>
    </div>
  );
}
